import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Typography from "@mui/material/Typography";
import {
  Box,
  CardActionArea,
  Chip,
  IconButton,
  Tooltip,
  alpha,
} from "@mui/material";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import EditIcon from "@mui/icons-material/Edit";
const CategoryCard = ({
  name,
  color,
  portada,
  lives,
  Icon,
  order,
  isActive,
  onClick,
  onEdit,
  dragHandleProps,
}) => {
  const cardColor = color || "#D0749B";

  return (
    <Card
      sx={{
        minWidth: 365,
        minHeight: 350,
        marginBottom: "3%",
        borderRadius: 8,
        transition: "transform 0.2s ease-in-out",
        position: "relative",
        "&:hover": {
          transform: "scale(1.05)",
        },
      }}
    >
      {/* Drag handle + order badge */}
      <Box
        sx={{
          position: "absolute",
          top: 8,
          left: 8,
          zIndex: 2,
          display: "flex",
          alignItems: "center",
          gap: 0.5,
        }}
      >
        {dragHandleProps && (
          <Tooltip title="Arrastrá para reordenar" placement="top">
            <Box
              {...dragHandleProps}
              sx={{
                display: "flex",
                alignItems: "center",
                cursor: "grab",
                color: "white",
                backgroundColor: "rgba(0,0,0,0.4)",
                borderRadius: 1,
                p: 0.25,
                "&:active": { cursor: "grabbing" },
              }}
            >
              <DragIndicatorIcon sx={{ fontSize: 20 }} />
            </Box>
          </Tooltip>
        )}
        {order != null && (
          <Box
            sx={{
              backgroundColor: "rgba(0,0,0,0.5)",
              color: "white",
              borderRadius: 1,
              px: 1,
              py: 0.25,
              fontWeight: 700,
              fontSize: "0.75rem",
            }}
          >
            #{order}
          </Box>
        )}
        <Chip
          size="small"
          label={isActive ? "Activa" : "Inactiva"}
          sx={{
            fontWeight: 600,
            fontSize: "0.68rem",
            height: 22,
            bgcolor: isActive ? alpha("#2e7d32", 0.85) : alpha("#000", 0.55),
            color: "white",
          }}
        />

        {/* Edit button */}
        {onEdit && (
          <Tooltip title="Editar categoría" placement="top">
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                onEdit();
              }}
              sx={{
                zIndex: 2,
                backgroundColor: "rgba(0,0,0,0.4)",
                color: "white",
                "&:hover": { backgroundColor: "rgba(0,0,0,0.6)" },
                width: 32,
                height: 32,
              }}
            >
              <EditIcon sx={{ fontSize: 18 }} />
            </IconButton>
          </Tooltip>
        )}
      </Box>

      {/* Lives count badge */}
      <Typography
        sx={{
          position: "absolute",
          right: "4%",
          top: "3%",
          backgroundColor: cardColor,
          borderRadius: 8,
          padding: "0.5% 3%",
          color: "white",
          textShadow: "1px 1px 2px rgba(0, 0, 0, 0.5)",
          zIndex: 1,
        }}
      >
        Vivos: {lives ? lives.length : 0}
      </Typography>

      <CardActionArea onClick={onClick}>
        <div>
          <CardMedia
            component="img"
            height="285"
            image={portada}
            alt="Portada"
          />
          {Icon && (
            <Icon
              sx={{
                position: "absolute",
                top: "44%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                fontSize: 120,
                color: cardColor,
                opacity: 1,
              }}
            />
          )}
        </div>
        <CardContent>
          <Typography
            gutterBottom
            variant="h6"
            component="div"
            textAlign={"center"}
            color={"GrayText"}
          >
            {name}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default CategoryCard;
